import { createTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import Tooltip from '@material-ui/core/Tooltip'
import CloudDownloadIcon from '@material-ui/icons/CloudDownloadOutlined'
import { IconButton, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const theme = createTheme({
  palette: {
    action: {
      disabled: '#9CA3AF',
    },
  },
})

function OfflineButton() {
  const { t } = useTranslation()

  const openInNewTab = url => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <ThemeProvider theme={theme}>
      <div style={{ marginRight: '5px' }}>
        <Tooltip title={t('OfflineButton:tooltip')}>
          <span>
            <IconButton
              aria-label='link to offline'
              aria-controls='button'
              color='inherit'
              disabled
              onClick={() => openInNewTab('https://offline.chedar.fr')}
            >
              <CloudDownloadIcon style={{ marginRight: '5px' }} />
              <Typography variant='subtitle2'>{t('OfflineButton:offline')}</Typography>
            </IconButton>
          </span>
        </Tooltip>
      </div>
    </ThemeProvider>
  )
}

export default OfflineButton
